export default {"src":"/_next/static/media/calendar_64.3ded78bc.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};